import {
  getAmountWithCurrency,
  parseNumberByPrecision,
  setTranslationValues,
} from '@pascal/pascal-core';
import { amountConverterPipe, toLocaleTimeString } from '../../../helpers';
import bonusShadowLight from '../../../assets/images/bonus-island/bonus-shadow-light.png';
import bonusImgBox from '../../../assets/images/bonus-island/img-box-money.png';
import { TKeys } from '../../../enums';

const BonusIslandWeb = ({
  t,
  loading,
  imageSrc,
  currency,
  setIsOpen,
  isFinished,
  currencyCode,
  tournamentRanges,
  tournamentEndDate,
  selectedRangeIndex,
  bottomPartSelections,
  tournamentSelections,
  tournamentStatusText,
  setSelectedRangeIndex,
  translateDisplayNames,
  rangeCollectedProgress,
  tournamentTotalPrizeFund,
  openMainBonusIslandInfoPopup,
}) => {
  const isChangePlacesOfAmountAndCurrencyCode = getAmountWithCurrency({
    isReturnPreValue: true,
    currencyCode: currency,
    currencyToShow: currencyCode,
  });

  const getDecidedAmount = (amount) => amountConverterPipe(parseNumberByPrecision(1, amount));
  return (
    <div className='bonus-isl-main'>
      <div className='bonus-island-main-wrapper-an'>
        <div className='bonus-island-main-wrapper'>
          <div className='bonus-island-main-top'>
            <div className='bon-isl-logo-wr'>
              <img src={bonusShadowLight} alt='shadow-light' className='img-bon-pop-sh' />
              <img src={imageSrc} alt='bonus-island' />
            </div>

            <div className='bon-isl-top-ins'>
              <div className='bon-isl-top-ins-cell' />
              <div className='bon-isl-top-ins-center'>
                <div className='isl-top-money-fl'>
                  {isChangePlacesOfAmountAndCurrencyCode ? (
                    <>
                      <div className='isl-top-money-fl-center'>
                        <span className='isl-top-money-fl-center-amd'>{currency}</span>
                      </div>
                      <div className='isl-top-money-fl-left'>
                        <p className='isl-top-money-fl-left-money'>
                          {getDecidedAmount(tournamentTotalPrizeFund)}
                        </p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className='isl-top-money-fl-left'>
                        <p className='isl-top-money-fl-left-money'>
                          {getDecidedAmount(tournamentTotalPrizeFund)}
                        </p>
                      </div>
                      <div className='isl-top-money-fl-center'>
                        <span className='isl-top-money-fl-center-amd'>{currency}</span>
                      </div>
                    </>
                  )}

                  <div className='isl-top-money-fl-right open-info'>
                    <div className='bon-isl-open-info top'>
                      <div className='bon-isl-open-info-ins'>
                        <p className='bon-isl-open-info-text'>
                          {setTranslationValues(t(TKeys.BONUS_ISLAND_HOVER_MESSAGE_1), {
                            tournamentTotalPrizeFundText: getAmountWithCurrency({
                              amount: getDecidedAmount(tournamentTotalPrizeFund),
                              currencyCode,
                            }),
                          })}
                        </p>
                      </div>
                    </div>
                    <span className='isl-top-money-fl-right-info'>
                      <i className='bc-i-info' />
                    </span>
                  </div>
                </div>
                <div className='isl-top-money-step'>
                  {tournamentRanges.map((range, ind) => (
                    <div
                      key={range.rangeId}
                      onClick={() => setSelectedRangeIndex(ind)}
                      className={`isl-top-money-step-ins ${
                        selectedRangeIndex === ind ? 'active' : ''
                      }`}
                    >
                      {isChangePlacesOfAmountAndCurrencyCode && (
                        <div className='money-step-ins-p-amd'>
                          <span>{currency}</span>
                        </div>
                      )}
                      {ind !== tournamentRanges.length - 1 && (
                        <p className='money-step-ins-p'>
                          {getDecidedAmount(range.minAmount)} - {getDecidedAmount(range.maxAmount)}
                        </p>
                      )}
                      {ind === tournamentRanges.length - 1 && (
                        <p className='money-step-ins-p'>
                          {getDecidedAmount(range.minAmount)}
                          <i className='bc-i-inclusive infinity-icon' />
                        </p>
                      )}
                      {!isChangePlacesOfAmountAndCurrencyCode && (
                        <div className='money-step-ins-p-amd'>
                          <span>{currency}</span>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              <div className='bon-isl-top-ins-cell'>
                <div className='bon-isl-top-ins-cell-ic'>
                  <span
                    className='isl-top-cell-icon-d-close'
                    onClick={openMainBonusIslandInfoPopup}
                  >
                    <i className='bc-i-help_popup' />
                  </span>
                  <span className='isl-top-cell-icon-d-close' onClick={() => setIsOpen(false)}>
                    <i className='bc-i-close' />
                  </span>
                </div>
                <div className='bon-isl-top-ins-cell-date'>
                  {!isFinished && (
                    <p className='p-isl-end-date'>{toLocaleTimeString(tournamentEndDate)}</p>
                  )}
                  <p className='p-isl-end-date'>{t(tournamentStatusText)}</p>
                </div>
              </div>
            </div>
          </div>
          <div className='bonus-island-main-bottom'>
            <div className='b-i-bot-content'>
              <div className='b-i-bot-wr'>
                {!loading && (
                  <div className='b-i-bot-wr-top'>
                    <div className='scroll-b scrollable-container'>
                      <div className='mid-area-island'>
                        {tournamentSelections.map((selection) => (
                          <div className='mid-area-island-row' key={selection.selectionId}>
                            <div className='mid-area-island-cell left'>
                              <p
                                className={`mid-ar-left-p ${
                                  selection.displayName.length > 8 ? 'small' : 'big'
                                }`}
                              >
                                {translateDisplayNames(selection.displayName)}
                              </p>
                            </div>
                            <div className='mid-area-island-cell center'>
                              <div className='m-ar-cell-ins'>
                                <div
                                  className='yellow-line-island'
                                  style={{ width: `${selection.userCollectedProgressWidth}%` }}
                                >
                                  {(!selection.userTournamentSelections ||
                                    !selection.userTournamentSelections.length ||
                                    !selection.userTournamentSelections[0].isCollected) && (
                                    <div className='m-ar-ins-cell-tooltip'>
                                      <p className='m-ar-ins-cell-tooltip-text'>
                                        {selection.userTournamentSelections[0]
                                          ? selection.userTournamentSelections[0].currentCount
                                          : 0}
                                        /{selection.nextNotCollectedStagePointsCount}
                                      </p>
                                    </div>
                                  )}
                                </div>
                                {selection.stages.map((stage) => (
                                  <div className='m-ar-ins-cell' key={stage.count}>
                                    <div className='m-ar-ins-cell-line' />
                                    <div className='m-ar-ins-right-con'>
                                      <div
                                        className={`d-r-money-top ${
                                          stage.userTournamentStages[0] &&
                                          stage.userTournamentStages[0].isCollected
                                            ? 'active'
                                            : ''
                                        }`}
                                      >
                                        <p className='p-r-money-top'>{stage.count}</p>
                                        <span className='sp-r-money-top'>{t('POINT')}</span>
                                      </div>
                                      <span
                                        className={`m-ar-ins-right-con-sp ${
                                          stage.userTournamentStages[0] &&
                                          stage.userTournamentStages[0].isCollected
                                            ? 'active'
                                            : ''
                                        }`}
                                      />
                                      <div
                                        className={`d-r-money-bottom ${
                                          stage.userTournamentStages[0] &&
                                          stage.userTournamentStages[0].isCollected
                                            ? 'active'
                                            : ''
                                        }`}
                                      >
                                        {isChangePlacesOfAmountAndCurrencyCode ? (
                                          <>
                                            <div className='d-r-money-bottom-right'>
                                              <span>{currency}</span>
                                            </div>
                                            <div className='d-r-money-bottom-left'>
                                              <p
                                                className={`p-r-money-bot ${
                                                  getDecidedAmount(stage.stagePrizes[0].prizeFund)
                                                    .length > 13
                                                    ? 'small'
                                                    : 'big'
                                                }`}
                                              >
                                                {stage.stagePrizes &&
                                                stage.stagePrizes[0] &&
                                                stage.stagePrizes[0].prizeFund
                                                  ? getDecidedAmount(stage.stagePrizes[0].prizeFund)
                                                  : ''}
                                              </p>
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            <div className='d-r-money-bottom-left'>
                                              <p
                                                className={`p-r-money-bot ${
                                                  getDecidedAmount(stage.stagePrizes[0].prizeFund)
                                                    .length > 13
                                                    ? 'small'
                                                    : 'big'
                                                }`}
                                              >
                                                {stage.stagePrizes &&
                                                stage.stagePrizes[0] &&
                                                stage.stagePrizes[0].prizeFund
                                                  ? getDecidedAmount(stage.stagePrizes[0].prizeFund)
                                                  : ''}
                                              </p>
                                            </div>
                                            <div className='d-r-money-bottom-right'>
                                              <span>{currency}</span>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                            <div className='mid-area-island-cell right'>
                              {!!selection.selectionPrizes?.[0]?.prizeFund && (
                                <div
                                  className={`m-ar-cell-r-ins ${
                                    selection.userTournamentSelections?.[0]?.isCollected
                                      ? 'active'
                                      : ''
                                  }`}
                                >
                                  <span className='m-ar-cell-r-ins-img' />
                                  <div className='m-ar-cell-r-ins-left'>
                                    <p className='m-ar-cell-r-ins-left-p'>
                                      {isChangePlacesOfAmountAndCurrencyCode ? (
                                        <>
                                          {currency}
                                          {getDecidedAmount(selection.selectionPrizes[0].prizeFund)}
                                        </>
                                      ) : (
                                        <>
                                          {getDecidedAmount(selection.selectionPrizes[0].prizeFund)}
                                          {currency}
                                        </>
                                      )}
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
                {tournamentRanges[selectedRangeIndex] && !loading && (
                  <div className='b-i-bot-wr-bottom'>
                    <div className='b-i-bot-wr-bottom-wr'>
                      <div className='b-i-bot-wr-bot-ins'>
                        <div className='b-i-bot-wr-bot-ins-left'>
                          <div className='b-i-bot-ins-yellow-wr'>
                            <div
                              className='b-i-bot-ins-yellow-line'
                              style={{
                                transform: `translateX(-${rangeCollectedProgress}%)`,
                              }}
                            />
                          </div>

                          {bottomPartSelections.map((selection, ind) => (
                            <div key={ind} className='b-i-bot-ins'>
                              <div className='b-i-bot-ins-line' />
                              <div
                                className={`b-i-bot-ins-circle ${
                                  selection.isCollected ? 'active' : ''
                                }`}
                              >
                                <span className='b-i-bot-ins-circle-int'>{ind + 1}</span>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className='b-i-bot-wr-bot-ins-right'>
                          <div className='b-isl-mon-r-wr'>
                            <div className='b-isl-mon-r-wr-left'>
                              <div className='b-isl-mon-r-wr-left-icon open-info'>
                                <span className='isl-top-money-fl-right-info'>
                                  <i className='bc-i-info' />
                                </span>
                                <div className='bon-isl-open-info bottom'>
                                  <div className='bon-isl-open-info-ins'>
                                    <p className='bon-isl-open-info-text'>
                                      {setTranslationValues(t(TKeys.BONUS_ISLAND_HOVER_MESSAGE_2), {
                                        levelsCount: tournamentSelections[0]?.stages.length,
                                        betTypes: tournamentSelections.length,
                                      })}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              {isChangePlacesOfAmountAndCurrencyCode ? (
                                <>
                                  <div className='b-isl-mon-r-wr-c'>
                                    <span>{currency}</span>
                                  </div>
                                  <div className='b-isl-mon-r-wr-l'>
                                    <p className='b-isl-mon-r-int'>
                                      {getDecidedAmount(
                                        tournamentRanges[selectedRangeIndex].totalPrizeFund
                                      )}
                                    </p>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className='b-isl-mon-r-wr-l'>
                                    <p className='b-isl-mon-r-int'>
                                      {getDecidedAmount(
                                        tournamentRanges[selectedRangeIndex].totalPrizeFund
                                      )}
                                    </p>
                                  </div>
                                  <div className='b-isl-mon-r-wr-c'>
                                    <span>{currency}</span>
                                  </div>
                                </>
                              )}
                            </div>
                            <div className='b-isl-mon-r-wr-r'>
                              <img src={bonusImgBox} alt='' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading && <div className='circle-loader' style={{ zIndex: 9 }} />}
    </div>
  );
};

export default BonusIslandWeb;
